
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-500 ease-out whitespace-nowrap cursor-pointer inline-flex items-center justify-center antialiased';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-red-700 shadow-lg hover:shadow-2xl transform hover:-translate-y-1 active:translate-y-0 hover:brightness-110',
    secondary: 'bg-secondary text-white hover:bg-gray-800 shadow-lg hover:shadow-2xl transform hover:-translate-y-1 active:translate-y-0 hover:brightness-110',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white shadow-md hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0',
    ghost: 'text-primary hover:bg-red-50 transform hover:scale-105 active:scale-95',
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      style={{ textRendering: 'optimizeLegibility', WebkitFontSmoothing: 'antialiased' }}
      {...props}
    >
      {children}
    </button>
  );
}
